<template>
    <div class="card">
        <div style="display: flex; justify-content: space-around; overflow: auto; height: 55px; align-items: center;">
            <div class="col-md-7" style="cursor:pointer; font-size: small;" @click="seleccionTodos()">TODOS&nbsp;</div>
            <div style="display: flex; justify-content: space-between;">
                <div >&nbsp;</div>
                <div><span class="badge badge-secondary" style="cursor:pointer" @click="seleccion('todos','nogreen')" title="En reparación">{{ totalFacturar }}</span>&nbsp;</div>
                <div> <span class="badge badge-success" style="cursor:pointer" @click="seleccion('todos','verde')" title="Pendiente de factura">{{ totalEnCurso }}</span></div>
            </div>
        </div>
        <Dropdown showClear v-model="companyiaseleccionada" :options="listadocompanyias" filter optionLabel="nombre"
            placeholder="Filtro Compañia">
            <template #option="slotProps">
                <div class="row" style="width: 100%;">
                        <div class="col-md-7" @click="seleccion(slotProps.option)"> {{ slotProps.option.nombre }}&nbsp;</div>
                        <div class="col-md-3"><span class="badge badge-primary">{{ slotProps.option.prefijo }}</span>&nbsp;</div>
                        <div class="col-md-1"> <span class="badge badge-secondary" title="En reparación" style="cursor:pointer" @click="seleccion(slotProps.option,'nogreen')">{{slotProps.option.cuantos - slotProps.option.cuantos_verde }}</span>&nbsp;</div>
                        <div class="col-md-1"> <span class="badge badge-success" style="cursor:pointer" @click="seleccion(slotProps.option,'verde')" title="Pendiente de factura">{{slotProps.option.cuantos_verde }}</span></div>
                </div>
            </template>
        </Dropdown>
        <DataTable class="mitabla" stripedRows :value="listadocompanyias" scrollable scrollHeight="1000px">
            <Column field="nombre">
                <template #body="slotProps">
                    <div v-scroll-right style="display: flex; justify-content: space-between; overflow: auto;">
                        <div class="col-md-7" style="cursor:pointer; font-size: small;" @click="seleccion(slotProps.data)" >{{ slotProps.data.nombre }}&nbsp;</div>
                        <div style="display: flex; justify-content: space-between;">
                            <div :title="slotProps.data.prefijo"><span class="badge badge-primary">{{slotProps.data.prefijo }}</span>&nbsp;</div>
                            <div><span class="badge badge-secondary" title="En reparación" style="cursor:pointer" @click="seleccion(slotProps.data,'nogreen')" >{{slotProps.data.cuantos - slotProps.data.cuantos_verde }}</span>&nbsp;</div>
                            <div> <span class="badge badge-success" title="Pendiente de factura" style="cursor:pointer" @click="seleccion(slotProps.data,'verde')" >{{slotProps.data.cuantos_verde }}</span></div>
                        </div>
                    </div>
                </template>
            </Column>
        </DataTable>
    </div>
</template>
<script>
import Dropdown from 'primevue/dropdown';
export default {
    props: ['contadoresCompanyias'],
    components: {
        Dropdown,
    },
    data() {
        return {
            listadocompanyias: [],
            companyiaseleccionada: '',
            totalEnCurso: 0,
            totalFacturar: 0
        };
    },
    methods: {
       listadoCompanyas(){ 
            const datos = this.$props.contadoresCompanyias || {};
            this.listadocompanyias = datos.companias || [];

            this.totalEnCurso = datos.total_verdes || 0;
            this.totalFacturar = datos.total_grises || 0;
            //this.$props.companyias.forEach(element => {
            //    this.totalEnCurso = this.totalEnCurso + parseInt(element.noFacturar);
            //    this.totalFacturar = this.totalFacturar + parseInt(element.facturar);
            //});
            //this.auxiliar = this.$props.companyias;
        },
        seleccionTodos(){
            this.$parent.cargarTodos();
        },
        seleccion(com,tipo){
            console.log('AA sel',com, tipo);
            
            if(!tipo){
            this.$parent.cargarseleccionada(com);
            }
            if(tipo == "verde"){
                this.$parent.cargarseleccionada(com,'verde');
            }
            if(tipo == "nogreen"){
                this.$parent.cargarseleccionada(com,'nogreen');
            }
       }    
    },
    mounted() {
        this.listadoCompanyas();
    },
    watch: {
        companyiaseleccionada(){
            if (this.companyiaseleccionada) {
                this.listadocompanyias = [];
                this.listadocompanyias.push(this.companyiaseleccionada);
            }
            else {
                this.listadocompanyias = this.$props.contadoresCompanyias.companias;
            }
        },
        contadoresCompanyias() {
            this.listadoCompanyas();
        }
    }
};
</script>
<style>
.codigo {
    cursor: pointer !important;
}
.mitabla .p-datatable-thead {
    display: none !important;
}
</style>
